import { action } from 'mobx';
import { BaseEditViewStore, BaasicDropdownStore } from 'core/stores';
import { CreateFacilityOrderTemplateForm } from 'application/facility-order/forms';
import { SubCategoryService } from "application/product/services";
import { FacilityOrderTemplateService } from "application/facility-order/services";
import _ from 'lodash';
import { subCategoriesSort } from 'core/utils';
class CreateFacilityOrderTemplateModalStore extends BaseEditViewStore {
    constructor(rootStore, componentProps) {
        const facilityOrderTemplateService = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);
        const subCategoryService = new SubCategoryService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'create-facility-order-template-modal',
            Form: CreateFacilityOrderTemplateForm,
            actions: () => {
                return {
                    create: async (resource) => {
                        const { facilityOrderId, patientId, subCategoryId } = resource;
                        
                        const response = await facilityOrderTemplateService.createBySubCategory(subCategoryId, facilityOrderId, patientId);
                        return response.data;
                    }
                }
            },
            FormClass: CreateFacilityOrderTemplateForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;

        this.patientId = this.modalParams.data.patientId;
        this.facilityOrderId = this.modalParams.data.facilityOrderId;
        this.setFacilityOrderTemplateList = this.modalParams.data.setFacilityOrderTemplateList;
        this.saveAllFacilityOrderTemplates = this.modalParams.data.saveAllFacilityOrderTemplates;

        this.subCategoryStore = new BaasicDropdownStore({}, {
            fetchFunc: async (term) => {
                const subCategorysAbrv = ["G-Tube", "Oral-Supplements", "Enteral", "Respiratory---trachs-supply", "Trach-Tube","Urologicals", "Ostomy-Products", "Wound-Care"];
                const response = await subCategoryService.find({ searchQuery: term, rpp: 100, sort: "itemCategory.name|asc", embed: "ItemCategory"});
                
                let data =  subCategoriesSort(response.data.item.map(i=> {return {...i, name: i.name}}));
                let filteredSubCategories = _.filter(data, i => {
                    return subCategorysAbrv.some(s => i.abrv === s);
                });

                return filteredSubCategories;
            }
        });
    }

    @action.bound
    async createResource(resource) {
        if (!this.actions.create) return;

        this.form.setFieldsDisabled(true);

        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }
            await this.saveAllFacilityOrderTemplates();

            await this.actions.create({
                ...resource,
                facilityOrderId: this.facilityOrderId,
                patientId: this.patientId
            });

            this.form.setFieldsDisabled(false);

            await this.setFacilityOrderTemplateList(this.facilityOrderId, this.patientId);
            this.modalParams.close();

            this.rootStore.notificationStore.success('Facility order template successfully generated.');
        } 
        catch(err) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error('Error occured while trying to create new facility order template.');
        }
    }
}

export default CreateFacilityOrderTemplateModalStore;
